module.exports = __webpack_public_path__ + "img/footer__prepend.841c2dda.svg";